import { createSheetTabParam } from '@repo/ui/components/molecules/sheet-tabs';

/**
 * Tab della pagina «Costi e piani» (pagina «P» del design + «Clienti»):
 * il tab viaggia sull'URL (`?tab=`), così un link o un reload riaprono lo
 * stesso tab; senza parametro è «Piani e marginalità».
 */
export const INFRASTRUCTURE_COSTS_TABS = [
  'plans',
  'cost-items',
  'supplier-contracts',
  'settings',
  'offer',
  'clients',
] as const;

export type InfrastructureCostsTab = (typeof INFRASTRUCTURE_COSTS_TABS)[number];

export const INFRASTRUCTURE_COSTS_DEFAULT_TAB: InfrastructureCostsTab = 'plans';

/** Il parametro della search che porta il tab. */
export const INFRASTRUCTURE_COSTS_TAB_SEARCH_KEY = 'tab';

/** Il contratto del tab nell'URL, letto da `useSheetTabSearch`. */
export const INFRASTRUCTURE_COSTS_TAB_PARAM = createSheetTabParam(
  INFRASTRUCTURE_COSTS_TABS,
  INFRASTRUCTURE_COSTS_DEFAULT_TAB
);

/** Etichetta di ogni tab: famiglia `infrastructureCosts.tabs.*`. */
export const INFRASTRUCTURE_COSTS_TAB_LABEL_KEYS = {
  plans: 'infrastructureCosts.tabs.plans',
  'cost-items': 'infrastructureCosts.tabs.cost_items',
  'supplier-contracts': 'infrastructureCosts.tabs.supplier_contracts',
  settings: 'infrastructureCosts.tabs.settings',
  offer: 'infrastructureCosts.tabs.offer',
  clients: 'infrastructureCosts.tabs.clients',
} as const satisfies Record<InfrastructureCostsTab, string>;

/**
 * Il tab da mostrare: quello dell'URL se il ruolo lo vede, altrimenti il
 * default (un referrer che apre `?tab=clients` resta su «Piani»).
 */
export function resolveVisibleInfrastructureCostsTab(
  value: unknown,
  visibleTabs: readonly InfrastructureCostsTab[]
): InfrastructureCostsTab {
  const tab = INFRASTRUCTURE_COSTS_TAB_PARAM.resolve(value);
  return visibleTabs.includes(tab) ? tab : INFRASTRUCTURE_COSTS_DEFAULT_TAB;
}
